(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class ImageBannerSlider {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-ibs-track]');
        this.originalSlides = Array.from(root.querySelectorAll('[data-ibs-slide]'));
        this.dots = Array.from(root.querySelectorAll('[data-ibs-dot]'));
        this.counterEl = root.querySelector('[data-ibs-counter-current]');
        this.prevBtn = root.querySelector('[data-ibs-prev]');
        this.nextBtn = root.querySelector('[data-ibs-next]');
        this.count = this.originalSlides.length;
        this.autoplay = root.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
        this.timer = null;
        this.transitioning = false;

        if (this.count <= 1) return;

        this.setupClones();
        // Track now has [last-clone, slide1, slide2, ..., slideN, first-clone]
        // Start at position 1 (the real first slide)
        this.position = 1;
        this.setTransform(false);
        this.updateIndicators();

        this.bindEvents();
        this.bindTransitionEnd();

        if (this.autoplay) this.startAutoplay();
      }

      setupClones() {
        const firstClone = this.originalSlides[0].cloneNode(true);
        const lastClone = this.originalSlides[this.count - 1].cloneNode(true);

        firstClone.setAttribute('aria-hidden', 'true');
        firstClone.setAttribute('data-ibs-clone', 'true');
        firstClone.removeAttribute('data-ibs-slide');

        lastClone.setAttribute('aria-hidden', 'true');
        lastClone.setAttribute('data-ibs-clone', 'true');
        lastClone.removeAttribute('data-ibs-slide');

        this.track.appendChild(firstClone);
        this.track.insertBefore(lastClone, this.track.firstChild);

        this.totalPositions = this.count + 2;
      }

      bindEvents() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go('prev'));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go('next'));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.index, 10);
            this.goTo(idx);
          });
        });

        this.root.addEventListener('mouseenter', () => this.stopAutoplay());
        this.root.addEventListener('mouseleave', () => { if (this.autoplay) this.startAutoplay(); });
        this.root.addEventListener('focusin', () => this.stopAutoplay());
        this.root.addEventListener('focusout', () => { if (this.autoplay) this.startAutoplay(); });

        let startX = 0;
        let dx = 0;
        let touching = false;

        this.track.addEventListener('touchstart', (e) => {
          touching = true;
          startX = e.touches[0].clientX;
          dx = 0;
          this.stopAutoplay();
        }, { passive: true });

        this.track.addEventListener('touchmove', (e) => {
          if (!touching) return;
          dx = e.touches[0].clientX - startX;
        }, { passive: true });

        this.track.addEventListener('touchend', () => {
          if (!touching) return;
          touching = false;
          if (Math.abs(dx) > 50) {
            this.go(dx < 0 ? 'next' : 'prev');
          }
          if (this.autoplay) this.startAutoplay();
        });

        this.root.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go('prev');
          if (e.key === 'ArrowRight') this.go('next');
        });
      }

      bindTransitionEnd() {
        this.track.addEventListener('transitionend', () => {
          this.transitioning = false;

          // We landed on the trailing clone (looks like slide 1) — snap silently to real slide 1
          if (this.position === this.totalPositions - 1) {
            this.position = 1;
            this.setTransform(false);
          }
          // We landed on the leading clone (looks like last slide) — snap silently to real last slide
          else if (this.position === 0) {
            this.position = this.count;
            this.setTransform(false);
          }
        });
      }

      go(direction) {
        if (this.transitioning) return;
        this.transitioning = true;

        if (direction === 'next') {
          this.position += 1;
        } else {
          this.position -= 1;
        }

        this.setTransform(true);
        this.updateIndicators();
      }

      goTo(realIndex) {
        if (this.transitioning) return;
        if (realIndex < 0 || realIndex >= this.count) return;
        const targetPosition = realIndex + 1; // skip leading clone
        if (targetPosition === this.position) return;

        this.transitioning = true;
        this.position = targetPosition;
        this.setTransform(true);
        this.updateIndicators();
      }

      setTransform(animate) {
        if (!animate) {
          this.track.style.transition = 'none';
          // Force reflow so the no-transition state is applied immediately
          // eslint-disable-next-line no-unused-expressions
          this.track.offsetHeight;
        } else {
          this.track.style.transition = '';
        }
        this.track.style.transform = `translateX(-${this.position * 100}%)`;
      }

      getRealIndex() {
        if (this.position === 0) return this.count - 1; // leading clone
        if (this.position === this.totalPositions - 1) return 0; // trailing clone
        return this.position - 1;
      }

      updateIndicators() {
        const realIdx = this.getRealIndex();

        this.originalSlides.forEach((slide, i) => {
          const isActive = i === realIdx;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', !isActive);
        });

        this.dots.forEach((dot, i) => {
          const isActive = i === realIdx;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (this.counterEl) {
          this.counterEl.textContent = realIdx + 1;
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => this.go('next'), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    function init() {
      document.querySelectorAll('.ibs-slider').forEach((el) => {
        if (!el.dataset.ibsInit) {
          new ImageBannerSlider(el);
          el.dataset.ibsInit = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
